import { render, staticRenderFns } from "./TabHealthcareReform.vue?vue&type=template&id=3575cad0&scoped=true"
import script from "./TabHealthcareReform.vue?vue&type=script&lang=js"
export * from "./TabHealthcareReform.vue?vue&type=script&lang=js"
import style0 from "./TabHealthcareReform.vue?vue&type=style&index=0&id=3575cad0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3575cad0",
  null
  
)

export default component.exports